const c = {
  name: "Fish",
  dimensions: { width: 40, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 34" style="enable-background:new 0 0 40 34;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M31.3,14c0,0.7-0.6,1.2-1.3,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C30.7,12.7,31.3,13.3,31.3,14z"
			/>
		<path class="st0" d="M3,0H0v3c0,2.5,1.4,4.8,3.4,6c-2,1.2-3.4,3.5-3.4,6v3h3c2.4,0,4.5-1.2,5.8-3.1c1.5,4.6,5.1,8.3,9.6,10
			c-2,1.2-3.4,3.5-3.4,6v3h3c3.9,0,7-3.1,7-7v-1c8.4-0.5,15-7.5,15-16V8H25V7c0-3.9-3.1-7-7-7h-3v3c0,2,0.8,3.7,2.1,5H10V7
			C10,3.1,6.9,0,3,0z M8,7v1H7C4.2,8,2,5.8,2,3V2h1C5.8,2,8,4.2,8,7z M38,10c0,7.7-6.3,14-14,14s-14-6.3-14-14H38z M23,7v1h-1
			c-2.8,0-5-2.2-5-5V2h1C20.8,2,23,4.2,23,7z M8,10v1c0,2.8-2.2,5-5,5H2v-1c0-2.8,2.2-5,5-5H8z M23,26v1c0,2.8-2.2,5-5,5h-1v-1
			c0-2.8,2.2-5,5-5H23z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Fish
};
